var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "75px",
    viewBox: "0 0 72.0 75.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1279 L0,1279 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-48.3870968%",
    y: "-46.1538462%",
    filterUnits: "userSpaceOnUse",
    width: "164.516129%",
    height: "161.538462%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.304128)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25539567,0 C3.24854674,0.0222857143 3.24785609,1.97767886 2.25539567,2 L0.744604328,2 C-0.248546736,1.97771429 -0.247856089,0.0223211429 0.744604328,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25539567,0 C3.24854674,0.0218285714 3.24785609,1.97812457 2.25539567,2 L0.744604328,2 C-0.248546736,1.97817143 -0.247856089,0.0218754286 0.744604328,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2824101,0 C16.2424397,0.0222857143 16.235948,1.979464 15.2824101,2 L0.717591345,2 C-0.243437012,1.97771429 -0.234947803,0.0200891429 0.717591345,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7907184,0 C44.3858398,0.381428571 46.1830737,19.2536571 33.0436978,22.2737143 L33.0436978,36 C39.0120763,36.2125714 39.0006612,44.7920743 33.0436978,45 L9.01191759,45 C6.527289,45 4.5059588,42.9813429 4.5059588,40.5 L4.5059588,26.25 L3.00397253,26.25 C1.34775373,26.25 0,24.9047143 0,23.25 L0,12 C0,10.3459714 1.34775373,9 3.00397253,9 L19.7524068,9 C20.7995058,3.8712 25.3506958,0 30.7907184,0 Z M19.5632767,10.5 L5.60596204,10.5 C5.87014855,10.9523143 5.99822249,11.4763371 6.00794506,12 L6.00794506,40.5 C6.00794506,42.1547143 7.35569879,43.5 9.01191759,43.5 C12.9795473,43.3753714 12.9826371,37.6254686 9.01172877,37.4999143 C8.59700891,37.4999143 8.26073564,37.16442 8.26073564,36.7499143 C8.26073564,36.3354086 8.59700891,35.9999143 9.01172877,35.9999143 L31.5415228,35.9999143 L31.5415228,22.4622 C28.8194945,22.6895143 26.1078514,21.7905429 24.0604296,20.25 L13.5173443,20.25 C13.1026244,20.25 12.7663511,19.9141714 12.7663511,19.5 C12.7663511,19.0858286 13.1026244,18.75 13.5173443,18.75 L22.4176857,18.75 C21.6204314,17.8633714 20.9579439,16.8555429 20.4724848,15.75 L13.5174301,15.75 C12.5297239,15.7332857 12.5310972,14.2664066 13.5174301,14.25 L19.9444722,14.25 C19.6159132,13.0687714 19.4479413,11.7612857 19.5632767,10.5 Z M33.0436978,37.5 L12.367784,37.5 C13.8798122,39.0623143 13.8801555,41.9376857 12.367784,43.5 L33.0436978,43.5 C34.6999166,43.5 36.0476704,42.1547143 36.0476704,40.5 C36.0476704,38.8452857 34.6999166,37.5 33.0436978,37.5 Z M4.5059588,12 C4.45497709,10.0225714 1.5532821,10.0229143 1.50198627,12 L1.50198627,23.25 C1.50198627,24.0770057 2.17553699,24.75 3.00397253,24.75 L4.5059588,24.75 Z M31.5415914,1.53771429 L31.5415914,2.24988 C31.5415914,2.66405143 31.2053181,2.99988 30.7905983,2.99988 C30.3758784,2.99988 30.0396052,2.66405143 30.0396052,2.24988 L30.0396052,1.53771429 C25.255221,1.90371429 21.4322282,5.72211429 21.0654518,10.5 L21.7785605,10.5 C22.1932804,10.5 22.5295537,10.8358286 22.5295537,11.25 C22.5295537,11.6641714 22.1932804,12 21.7785605,12 L21.0654518,12 C21.4319364,16.7780571 25.2553927,20.5959943 30.0396052,20.9622857 L30.0396052,20.25012 C30.0396052,19.8359486 30.3758784,19.50012 30.7905983,19.50012 C31.2053181,19.50012 31.5415914,19.8359486 31.5415914,20.25012 L31.5415914,20.9622857 C36.3259756,20.5962857 40.1489683,16.7778857 40.5157448,12 L39.802636,12 C38.8156165,11.9836286 38.8152732,10.5167409 39.802636,10.5 L40.5157448,10.5 C40.1492601,5.72194286 36.3258039,1.90400571 31.5415914,1.53771429 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32754777,0 C2.75762005,0 3.10634173,0.335827372 3.10634173,0.749997321 L3.10634173,5.3882379 C4.35935712,5.77497938 5.0581863,7.30745962 4.42993544,8.46391263 L6.77183562,10.7199046 C7.07605479,11.0125321 7.07605479,11.4873018 6.77183562,11.7802722 C6.46797247,12.0732426 5.97497364,12.0732426 5.67075447,11.7802722 L3.32849827,9.52462313 C0.347542013,10.7757901 -1.46424425,6.52797669 1.54875381,5.3882379 L1.54875381,0.749997321 C1.54875381,0.335827372 1.8974755,0 2.32754777,0 Z M2.32789489,6.74995875 C0.852734528,6.90064393 1.73646541,8.93737951 2.88382917,8.02195421 C3.36533745,7.58198435 2.99995402,6.72786083 2.32789489,6.74995875 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181.0 -899.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(196.0 914.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 14.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-7.77156117e-16,0 3,0 3,2 -7.77156117e-16,2 -7.77156117e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 19.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-7.77156117e-16,0 3,0 3,2 -7.77156117e-16,2 -7.77156117e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 23.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-7.77156117e-16,0 3,0 3,2 -7.77156117e-16,2 -7.77156117e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.0 23.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-4.4408921e-16,0 16,0 16,2 -4.4408921e-16,2 -4.4408921e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 28.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-7.77156117e-16,0 3,0 3,2 -7.77156117e-16,2 -7.77156117e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.0 28.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-4.4408921e-16,0 16,0 16,2 -4.4408921e-16,2 -4.4408921e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.0 32.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-7.77156117e-16,0 3,0 3,2 -7.77156117e-16,2 -7.77156117e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.0 32.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-4.4408921e-16,0 16,0 16,2 -4.4408921e-16,2 -4.4408921e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 42,0 42,45 0,45 0,0",
    stroke: "none",
    fill: "#55BAB0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.4408921e-16,0 7,0 7,12 4.4408921e-16,12 4.4408921e-16,0",
    stroke: "none",
    fill: "#55BAB0"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogLogo);
export default __webpack_public_path__ + "static/media/log-logo.1dfb530aa6b64dc57bcd8a5b6a5102f1.svg";
export { ForwardRef as ReactComponent };